import { motion } from "framer-motion";

export const PageHeader = ({ overline, title, accent, copy }) => (
  <section data-testid="page-header" className="relative pt-44 pb-16 sm:pb-20 overflow-hidden">
    <div className="absolute inset-0 grid-bg" aria-hidden="true" />
    <motion.div
      aria-hidden="true"
      className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[360px] rounded-full bg-[#6D00FF]/15 blur-[140px]"
      animate={{ opacity: [0.5, 0.8, 0.5] }}
      transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="text-xs font-bold uppercase tracking-[0.28em] text-[#8B2CFF] mb-6"
      >
        {overline}
      </motion.p>
      <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase tracking-tighter leading-[1.0]">
        <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          >
            {title}
          </motion.span>
        </span>
        {accent && (
          <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className="block text-gradient-purple"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, delay: 0.42, ease: [0.22, 1, 0.36, 1] }}
            >
              {accent}
            </motion.span>
          </span>
        )}
      </h1>
      {copy && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.65 }}
          className="mt-7 max-w-xl text-base sm:text-lg text-[#A6A6B0] leading-relaxed"
        >
          {copy}
        </motion.p>
      )}
    </div>
  </section>
);
